<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "Message",
  
})
</script>
<template>
	<div ref="messageRef" class="flex w-full items-start" :class="[{ 'flex-row-reverse': inversion,'mb-6': inversion,'mt-8': inversion,'mb-3': !inversion&&messageAgent!='search'},className]">
		<div v-if="!isMobile && messageAgent!='search'&&from!='share'" :class="['flex-shrink-0', inversion ? 'ml-2' : 'mr-2']">
			<AvatarComponent :from="from" v-if="!isMobile" :isLast="isLast" :isLoading="loading" :image="inversion" :icon="avatar" :userIcon='userIcon'/>
		</div>
		<!-- 选择框 -->
	
		<div class="font16 max-w-full items-start" :class="[messageAgent==='search' ? 'flex-1' : '',inversion?'fullWidth':'']">
			<div class="check-box" v-if="inversion&&chatStore.showCheck&&!props.from" :class="{isMobileCheck:isMobile}">
			<w-checkbox class="check"  v-model="props.checked" @change="handleeSelect"></w-checkbox>
		</div>
			<p v-if="!inversion" class="text-xs text-[#b4bbc4] " :class="[!inversion ? 'text-right' : 'text-left']">
				<div class="flex flex-wrap items-center justify-start" v-if="from!='share'">
					<!-- <div class="tagList" v-if="chatMode">
						<span>{{ $t('chat.center.role') }}</span>：<span >{{ currentRole?.roleName ? currentRole?.roleName : '小雅' }}</span><span class="tip">
								|
							</span>
					</div> -->
					<!-- <div class="tagList" v-if="source&&!model2VersionFlag">
						<span>{{ $t('chat.center.plugin') }}：{{ source }}</span>
						<span class="tip">
								|
							</span>
					</div> -->
					<!-- <div class="tagList" v-for="(item,key) in paramData" :key="key" >
							<span  v-if="item != $t('common.model.intelligenTitle')">{{key}}：</span>
							<span v-if="typeof(item) === 'object'">
								<span  v-for="(val,index) in item" :key="index+val">
									{{val}}
								</span>
							</span>
						
							<span v-else>{{item == '无' ? $t('chat.center.YaYi') : item}}</span>
							<span class="tip">
								|
							</span>
					</div> -->
					<!-- <div class="pluinDetailBtn"  v-if="pluginOutput&&!model2VersionFlag"  @click="handlePluinDetail">{{ $t('chat.center.detail') }}<SvgIcon :size="16" v-if="isShowDetail" name="cool-ArrowUpSLineWe" /><SvgIcon v-else :size="16" name="cool-ArrowDownSLineWe" /></div> -->
				</div>
				<div class="pluinDetailContent" v-if="isShowDetail">
						<!-- <div class="m-b">{{ $t('chat.center.callPlugin') }}：{{ webSourceList }}</div> -->
						<div class="m-b">{{ $t('chat.center.callPlugin') }}：{{ source }}</div>
						<div class="m-b no">{{ $t('chat.center.pluginTime') }}：{{ consumingTime?.toFixed(2) }}{{ $t('chat.center.seconds') }}</div>
						<div v-if="pluginOutput">{{ $t('chat.center.pluginResult') }}：
						<span class="markdown-body markdown-body-detail"
								:class="['1markdown-body-as-img-' + isMarkdownImg.length, chatStore.isLightTheme ? 'hljs-atom-one-light' : 'hljs-atom-one-dark']"
								v-html="handlePluginOutput">
						</span>
            </div>
				</div>
			</p>
			<div class=" items-end gap-1 relative" @animationend="() => { isAnimating = false }" :class="[inversion ? 'flex flex-row-reverse' : 'flex-row',loading && isAnimating?inversion?'animate__animated animate__fadeInUp animate__faster':'animate__animated animate__fadeInUp animate__faster  animate__delay-1s':'']" ref="textRef">
				<w-tooltip  v-if="inversion&&from!='share'"  placement="br"  :show-arrow="false" :popup-offset="-10" :arrow-style="{right: 0,left:'inherit'}" :update-at-scroll="true" background-color="#fff" :content-style="{padding: 0,borderRadius: '4px',width: wi + 'px',
         display: 'flex',
	       maxWidth:'900px',
	       minWidth:'100px',
         justifyContent: 'flex-end',
         background: 'transparent'}">
					<template #content v-if="inversion">
						<div style="background: #fff;padding: 6px 16px;border-radius: 4px">
							<span :title="$t('chat.center.edit')" class="editQuestion">
								<CoolBianji_9oe2ecpc @click="edit()" size="18" color="#9A99AA" style="cursor:pointer;" />
							</span>
							<span class="copyQuestion">
							<CoolFuzhi_9oe2ecmc :title="$t('chat.center.copy')" @click="copy(question,fileUrl)"  size="16" color="#9A99AA" style="cursor:pointer;" />
							</span>
						</div>

					</template>
				<TextComponent
					:from="from"
					:inversion="inversion"
					:loading="loading"
					:citations="citations"
					:dialogueFileIds="dialogueFileIds"
					:dialogueFolderIds="dialogueFolderIds"
					:paragraph="paragraph || ''"
					:skillId="skillId"
					:text="inversion ? question : answer"
					:as-raw-text="false"
					:asRawText="asRawText"
					:fileId="fileId"
					:fileUrl="fileUrl"
					:files="files"
					:fileName="fileName"
					:type="type"
					:params="param"
                    :resInfoState="resInfoState"
					:resInfos="resInfos"
					:modelVersion="modelVersion"
					:index="index"
					:stages="stages"
					:answerFinish="answerFinish"
					:source="source"
					:id="id"
					:answerType="answerType"
					:showStages="showStages"
					:roleName="roleName"
					:roleIcon="roleIcon"
					v-model:isHighlightCode="isHighlightCode"
					:round="round"
					:uuid="uuid"
					:chatType="chatType"
					:isLast="isLast"
					:gender="gender"
					:age="age"
					:chatQuestion="chatQuestion"
					:roleId="roleId"
				></TextComponent>
				</w-tooltip>
				<TextComponent
					v-if="inversion&&from=='share'"
					:from="from"
					:inversion="inversion"
					:loading="loading"
					:citations="citations"
					:dialogueFileIds="dialogueFileIds"
					:dialogueFolderIds="dialogueFolderIds"
					:paragraph="paragraph || ''"
					:skillId="skillId"
					:text="inversion ? question : answer"
					:as-raw-text="false"
					:asRawText="asRawText"
					:fileId="fileId"
					:fileUrl="fileUrl"
					:files="files"
					:fileName="fileName"
					:type="type"
					:params="param"
                    :resInfoState="resInfoState"
					:resInfos="resInfos"
					:modelVersion="modelVersion"
					:width="width"
					:index="index"
					:stages="stages"
					:id="id"
					:answerFinish="answerFinish"
					:source="source"
					:answerType="answerType"
					:showStages="showStages"
					:roleName="roleName"
					:roleIcon="roleIcon"
					v-model:isHighlightCode="isHighlightCode"
					:round="round"
					:uuid="uuid"
					:chatType="chatType"
					:isLast="isLast"
					:gender="gender"
					:age="age"
					:chatQuestion="chatQuestion"
					:roleId="roleId"

				></TextComponent>
				<template v-if="!inversion">
					<!-- <transition name="fade" mode="out-in"> -->
				<TextComponent
					:key="id"
					v-if="!inversion"
					:from="from"
					:inversion="inversion"
					:loading="loading"
					:citations="citations"
					:dialogueFileIds="dialogueFileIds"
					:dialogueFolderIds="dialogueFolderIds"
					:paragraph="paragraph || ''"
					:skillId="skillId"
					:text="inversion ? question : answer"
					:as-raw-text="false"
					:asRawText="asRawText"
					:params="param"
					:fileId="fileId"
					:fileUrl="fileUrl"
					:files="files"
					:fileName="fileName"
					:type="type"
					:resInfoState="resInfoState"
					:resInfos="resInfos"
					:modelVersion="modelVersion"
					:width="width"
					:index="index"
					:stages="stages"
					:id="id"
					:answerFinish="answerFinish"
					:source="source"
					v-model:isHighlightCode="isHighlightCode"
					v-model:callapseOrigin="callapseOrigin"
					:messageAgent="messageAgent"
					:searchEngineList="searchEngineList"
					:searchEngineType="searchEngineType"
					:answerType="answerType"
					:showStages="showStages"
					:roleName="roleName"
					:roleIcon="roleIcon"
					:round="round"
					:uuid="uuid"
					:chatType="chatType"
					:gender="gender"
					:age="age"
					:isLast="isLast"
					:chatQuestion="chatQuestion"
					:roleId="roleId"
				>
				<template #footer  v-if="!inversion && !loading&&from!='share'&&!getTicketId()&&route.name!='checkLogs'">
					<!-- <div class="message-tip fontFam">{{ $t('chat.center.tip') }}</div> -->				
					<div class="btns adaption" :class="{mobileBtns:isMobile}">
						<div class="dcm-info" v-if="!loading&&isLast&&props?.chatType==5&&props?.contentType!=3&&chatStore.getListHistory">
						<div class="text">对话已失效，请重新发起</div>
					</div>
						<div class="rebuildBtn fontFam">
							<template v-if="props.isLast||props?.chatType==5">
							<template v-if="!chatStore.isSensitive&&getLastChatItem?.hiddenInput!=1&&(!props?.chatType||props?.chatType!=5)">
								<w-button  type="text" class="cxsc" :class="{mobileCxcs:isMobile}" @touchend.prevent="handleSelect('toggleRender')" @click="handleSelect('toggleRender')">
									<template #icon>
										<w-tooltip background-color="#646479"  content-class="fontFam" :content="$t('chat.center.regenerate')" placement="top" >
										<CoolRefreshLineWe  size="18"/>
										</w-tooltip>
									</template>
								</w-button>
							</template>
							<answerSwitch v-if="regens && regens.length > 1" :oldregens="oldregens"></answerSwitch>
						</template>
						</div>
						<div v-if="appId !='20'  && answerType != 3&&route.name!='checkLogs'&&!getTicketId()" class="otherBtn">
							<w-tooltip background-color="#646479"  content-class="fontFam" :content="$t('chat.center.share')" placement="top"  mini>
								<w-button type="text" shape="circle" @click="handleShare">
									<CoolCaozuofenxiang1x  size="18"/>
								</w-button>
							</w-tooltip>
							<template v-if="!isup && !isdown">
                <w-popconfirm
                    v-if="hasId"
                    update-at-scroll
                    :popup-container="textRef"
                    content-class="popoverClass fontFam"
					:popup-visible="showLikePop"
                    @popup-visible-change="popupchange"
                    :ok-text="$t('chat.center.submit')"
                    @ok="feedbacksubmit(1)"
					@cancel="showLikePop=false"
                    placement="top"
                    trigger="click"
                    mini>
									<w-tooltip background-color="#646479" popup-container=".icon-like" content-class="fontFam" :content="$t('chat.center.like')" placement="top"  mini>
                  <w-button type="text" shape="circle"  class="icon-like" @click="showLikePop=true">
                    <CoolThumbUpLineWe  size="18"/>
                  </w-button>
									</w-tooltip>
                  <template #content>
                    <div class="popcontent">
                      <h2>{{ $t('chat.store.zanFormTitle') }}</h2>
                      <w-checkbox-group v-model="zanValue" direction="vertical">
                        <w-checkbox v-for="(item,index) in chatStore.zanForm.options" :key="index" :value="item.id" >{{item.content}}</w-checkbox>
                      </w-checkbox-group>
                      <w-textarea v-model="zanText" :placeholder="$t('chat.store.zanFormPlaceholder')" :max-length="200" show-word-limit :auto-size="{ minRows: 3,maxRows: 3 }"/>
                    </div>
                  </template>
                </w-popconfirm>

                <w-button v-else type="text" shape="circle" @click="handleFeedbackClick('like')" >
                  <CoolThumbUpLineWe  size="18" />
                </w-button>
              </template>
							<w-button type="text" v-else shape="circle" :disabled="isdown">
								<CoolThumbUpLineWe v-if="!isup" size="18" />
								<CoolThumbUpFillWe v-else size="18" />
							</w-button>
							<template v-if="!isup && !isdown">
                <w-popconfirm
                    v-if="hasId"
                    update-at-scroll
                    :popup-container="textRef"
					:popup-visible="showDisLikePop"
                    content-class="popoverClass fontFam upPopover"
                    @popup-visible-change="popupchange"
                    :ok-text="$t('chat.center.submit')"
                    @ok="feedbacksubmit(0)"
					@cancel="showDisLikePop=false"
                    :content="!isdown ? $t('chat.center.down'): $t('chat.center.alreadyDown')"
                    placement="top"
                    trigger="click"
                    mini>
									<w-tooltip background-color="#646479" popup-container=".icon-nolike" content-class="fontFam" :content="$t('chat.center.nolike')" placement="top"  mini>
                  <w-button type="text" shape="circle" @click="showDisLikePop=true">
                    <CoolThumbDownLineWe size="18" class="icon-nolike"/>
                  </w-button>
									</w-tooltip>
                  <template #content>
                    <div class="popcontent" >
                      <h2>{{ $t('chat.store.caiFormTitle') }}</h2>
										
                      <w-checkbox-group v-model="caiValue" direction="vertical">
                        <w-checkbox  v-for="(item,index) in chatStore.caiForm.options" :key="index" :value="item.id" >{{item.content}}</w-checkbox>
                      </w-checkbox-group>
                      <w-textarea v-model="caiText" :placeholder="$t('chat.store.caiFormPlaceholder')" :max-length="200" show-word-limit :auto-size="{ minRows: 3,maxRows: 3 }"/>
                    </div>
										<div class="bottomBtn" @click="openReport">
											<!-- <CoolJubao  size="14" color="#9A99AA"/> -->
											<CoolJubaoF3gpddkc  size="18" color="#9A99AA"/>
											<span class="title">{{ $t('chat.store.report') }}</span>
										</div>
                  </template>
                </w-popconfirm>
                <w-button v-else type="text" shape="circle" @click="handleFeedbackClick('dislike')">
                  <CoolThumbDownLineWe size="18" />
                </w-button>
              </template>
							<w-button type="text" v-else  shape="circle" :disabled="isup">
								<CoolThumbDownLineWe v-if="!isdown" size="18" />
								<CoolThumbDownFillWe v-else size="18" />
							</w-button>
							<!-- <w-tooltip :content="$t('chat.center.example')" placement="top"  mini>
								<w-button v-if="isShowExport" type="text" shape="circle" @click="getExport"><CoolShilidaima  size="14" /></w-button>
							</w-tooltip> -->
							<w-tooltip background-color="#646479" content-class="fontFam" :content="!iscopy ? $t('chat.center.copy') : $t('chat.center.alreadyCopy')" placement="top"  mini>
								<w-button type="text" shape="circle" @click="handleSelect('copyText')">
									<CoolFuzhi_9oe2ecmc v-if="!iscopy" size="18" />
									<CoolCheckLineWe v-else size="18" />
								</w-button>
							</w-tooltip>
							<template v-if="messageAgent === 'search' && isLast && !chatStore.isSensitive">
								<w-divider direction="vertical" />
								<w-button  type="text" class="probe-btn" @click="isProbe = !isProbe;">
									<template #icon>
										<CoolZhuiwen  size="18" />
									</template>
									{{$t('chat.center.ask')}}
								</w-button>
							</template>
							<!-- <w-tooltip background-color="#646479" content-class="fontFam" :content="$t('chat.center.play')" placement="top"  mini>
								<w-button type="text" shape="circle" v-if="!inversion && Session.get('yayiFlag')==='true'" @click="handleBofang"><CoolVolumeUpLineWe  size="14" /></w-button>
							</w-tooltip> -->
						</div>
					</div>
					<div class="probe-input" v-if="isProbe">
						<inputBox ref="inputRef" :searchEngineType="searchEngineType" :searchEngineList="searchEngineList"   v-click-outside="onClickOutside" @sendQuestion="sendQuestion" :from="'probe'"  :placeHolder="probeText"></inputBox>
					</div>
					<p v-if="answerExceedLengthLimit && answerFinish && isLast" class="continue-text">
					<!-- <p class="continue-text"> -->
						<template v-if="from === 'manageHistory'">
							{{ $t('chat.center.continueText') }}{{ $t('chat.center.continueButton') }}
						</template>
						<template v-else>
							{{ $t('chat.center.continueText') }}<w-button @click="continueDialogue($t('chat.center.continueButton'))" type="outline" size="small">{{ $t('chat.center.continueButton') }}</w-button>
						</template>
					</p>
				</template>
				<!-- <template #longWriter v-if="source === '长文生成器' && !loading && isLast&&from!='share'&&!isMobile">
					<div
						class="left-item"
						:class="['animate__animated', 'animate__fadeInUp', `animate__delay-${1 * 1}s`]"
						@click="openWriter"
					>
						<div class="item-name">
							<CoolChanpinXiezuoJianbian size="20" class="icon" />
							<span class="name">{{$t('chat.center.writerInfo')}}</span>
						</div>
						<div class="item-arrow">
							<CoolQianwang class="pointer" size="16" color="#9A99AA" />
						</div>
					</div>
					
				</template> -->
				<template #question v-if="!chatMode">
					<div class="question" v-if="!fileUrl && !chatStore.isSensitive && !sensitive && !inversion && !loading && isLast && id != 'undefined' && (requestLoading || questionList.length)">
						<div class="btns">
							<span class="title">{{ $t('chat.center.alsoAsk') }}</span>
						</div>
						<div class="list">
							<w-skeleton v-if="!questionList.length && requestLoading" :animation="true">
								<w-space direction="vertical" :style="{width:'100%'}" size="default">
									<w-skeleton-line :rows="3" />
								</w-space>
							</w-skeleton>
							<template  v-for="(item,index) in questionList">
							<div class="item" v-if="index < 3" :key="index" @click="sendQuestion(item)">
								{{index+1}}. {{ item }}
								<CoolArrowRightUpLineWe class="icon" size="20"/>
							</div>
							</template>
						</div>
						<div class="btns questionfooter" v-if="questionList.length">
							<div class="rebuildBtn">
								<span @click="changeQuestion()" v-if="questionList.length">
									<CoolRefreshLineWe  size="14"/>
									{{ $t('chat.center.changeQuestion') }}
								</span>
							</div>
						</div>
					</div>
				</template>
				</TextComponent>
			<!-- </transition> -->
			</template>
				
				
			</div>
			<!-- 多文档 -->	
			<div v-if="inversion&&files&&files.length" @animationend="() => { isAnimating = false }" :class="[loading && isAnimating?inversion?'animate__animated animate__fadeInUp animate__faster':'animate__animated animate__fadeInUp animate__faster  animate__delay-1s':'']">
				<fileLists :inversion="inversion" :question="question" :files="files" :from="from"></fileLists>
			</div>
		</div>
		<w-modal v-model:visible="exportVisible" :footer="false" hide-cancel modal-class="exampleModal" :width="800" :modal-style="{height: '700px'}">
			<template #title>
        {{ $t('chat.center.example') }}
			</template>
			<div class="exampleClass">
			<div class="ff">
					<span class="tabs">
					<w-tabs default-active-key="2" >
							<w-tab-pane key="2" title="JAVA" ></w-tab-pane>
					</w-tabs>
					</span>
					<span @click="copyCode"><CoolCheckboxMultipleBlankLineWe  size="16" style="margin-right: 4px;" />{{ $t('chat.center.copyCode') }}</span></div>
					<div class="detail">
					<div class="markdown-body"  v-html="htmlStrcode" />
					</div>
			</div>
		</w-modal>
		<w-modal v-model:visible="reportVisible"  :footer="false" hide-cancel modal-class="reportModal" @close="cancelModel">
			<template #title>
        {{ $t('chat.store.report') }}
			</template>
			<div class="content">
				<div class="head">
					<span class="red">*</span>
					<span class="title">{{$t('chat.store.type')  }}</span>
				</div>
				<div class="list">
					<div class="list-item" v-for="item in reportList" :key="item.id" :class="{active:item.select}" @click="handleReport(item)">
						{{ item.content }}
					</div>
				</div>
				<div class="input-box">
					<div class="title">{{$t('chat.store.desc')  }}</div>
					<w-textarea v-model="reportText" :placeholder="$t('chat.store.placeHold')" :max-length="120" show-word-limit :auto-size="{ minRows: 3,maxRows: 3 }"/>
				</div>
				<div class="btns">
					<div class="cancel" @click="cancelModel">{{$t('chat.category.deleteCancel')  }}</div>
					<div class="confirm" @click="confirmModel">{{$t('chat.center.submit')  }}</div>
				</div>
			</div>
		</w-modal>
	</div>
</template>

<script setup lang="ts" name="Message">
import { computed, onMounted, ref, reactive, watch } from 'vue';
import AvatarComponent from './Avatar.vue';
// import inputBox from '/@/views/aiSearch/components/inputBox/index.vue';
import inputBox from './components/inputBox/index.vue';
import { useRoute, useRouter } from 'vue-router';
import TextComponent from './Text.vue';
import answerSwitch from './answerSwitch.vue';
import fileLists from './fileLists.vue';
import { useChatStore } from '/@/stores/chat';
import { Session } from '/@common/utils/storage';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import { feedback } from '/@/api/chat';
import { Modal, Message } from 'winbox-ui-next';
import { dialogueCode, listDialogueQuestion, listAiSearchQuestion } from '/@/api/chat';
import mittBus from '/@common/utils/mitt';
import { getDialoguePlugins, feedbackListLabel } from '/@/api/chat';
import { useUserInfo } from '/@/stores/userInfo';
const storesUserInfo = useUserInfo();
import { copyText } from '/@common/utils/format';
import { addLoadEventToImgTags, initMessageMarkdown, textToMarkdown, initTextMarkdown } from '/@common/utils/markdown';
import { useI18n } from 'vue-i18n';
import { useRoleConfig } from '/@/stores/role';
import { getTicketId } from "/@common/utils/utils.ts"
import { isNotEmptyObject } from '/@common/utils/other';
const showDisLikePop=ref(false)
const showLikePop=ref(false)
const { isMobile } = useBasicLayout();
const { t } = useI18n();
const fold = ref(true);
const reportVisible = ref(false);
const callapseOrigin = ref(false);
const reportList = ref([]);
const reportLabel = ref([]);
const reportText = ref('');
interface Props {
	answer?: string;
	citations?: [];
	regens?: [];
	oldregens?: [];
	createTime?: string;
	id?: string;
	groupId?: string;
	dialogueFileIds?: any;
	dialogueFolderIds?: any;
	paragraph?: string;
	skillId?: string;
	param?: any;
	question: string;
	inversion?: boolean;
	loading?: boolean;
	isLast?: boolean;
	feedBackStatus?: string;
	fileId?: string;
	fileUrl?: string;
	files?: [];
	fileName?: string;
	type?: string;
	sensitive?: boolean;
	pluginOutput?: string;
	source?: string;
	consumingTime?: string | number;
	avatar?: string;
	resInfoState?: string;
	from?: string;
	resInfos?: [];
	checked?: boolean;
	answerExceedLengthLimit?: boolean;
	answerFinish?: boolean;
	modelVersion?: string;
	width?: number;
	pluginSwitch?: boolean;
	index?: number;
	stages?: [];
	messageAgent?: string;
	isEdit?: string;
	searchEngineList?: [];
	searchEngineType?: number;
	answerType?: number;
	showStages?: boolean;
	roleName?: string;
	roleIcon?: string;
	round?: number;
	chatType?: number;
	uuid?: string;
	gender?: string;
	age?: number;
	chatQuestion?:object,
	contentType?:number|string
	roleId?:string
	userIcon?:string

}
interface Emit {
	(ev: 'regenerate'): void;
	(ev: 'delete'): void;
	(ev: 'changeCheck'): void;
}

// 获取当前技能tab
const foldFiles = () => {
	fold.value = !fold.value;
};
const router = useRouter();
const props = defineProps<Props>();
const chatStore = useChatStore();
const asRawText = ref(props.inversion);
const checkBoxValue = ref(props.checked);
const exportVisible = ref(false);
const exampleCode = ref('');
const htmlStrcode = ref('');
import { setScrollPosition } from '/@common/utils/other';
const mdi = initTextMarkdown();
const className = computed(() => {	
	if (props.inversion) {
		return isMobile.value ? 'isPaddingRightMobile' : 'isPaddingRight';
	} else {
		return isMobile.value ? 'isPaddingLeftMobile' : props.messageAgent === 'search'? '' : 'isPaddingLeft';
	}
});
const isQuestionStatus = computed(() => !props.inversion && !props.loading && props.isLast);
const hasId = computed(() => props.id && props.id !== 'undefined');
const questionList = ref([]);
const requestLoading = ref(true);
const isAnimating = ref(true);
const isShowExport = computed(() => {
	return route.name == 'knowledge' || props.fileUrl ? false : true;
});
const wi = ref(0);
onMounted(() => {
	wi.value = textRef.value?.clientWidth;
});

const zanValue = ref([]);
const caiValue = ref([]);
const zanText = ref('');
const caiText = ref('');
const iscopy = ref(false);

const isup = ref(false);
const isdown = ref(false);
const isfinish = ref(false);
let isHighlightCode = ref(false);
const isMarkdownImg = ref([]);

const isProbe = ref(false);

const timer = ref(null);
const textRef = ref<HTMLElement>();
const messageRef = ref<HTMLElement>();
const route = useRoute();
let chatMode = computed(() => route.path.indexOf('chat') != -1 || route.path.indexOf('share'));
const { appId } = route.params as { appId: string };
const webSourceList = computed(() => {
	let val;
	chatStore.pluginListAll.forEach((item) => {
		if (item.value == props.source) {
			val = item.label;
		}
	});
	return val;
});
const roleConfig = useRoleConfig();
const model2VersionFlag = computed(() => {
	return chatStore.modelVersion == 'YAYI-V2.5-30B-8K';
});
const currentRole = computed(
	() => roleConfig.currentRoleInformation
	// roleConfig.getCurrentRoleByRoleId(roleConfig.currentRole)
);
const getLastChatItem=computed(()=>{
	return chatStore.lastItem
})

const getIcon = (icon: string) => {
	const iconMap = {
		txt: 'CoolTxt',
		//  'md': 'CoolMarkdownB50n94pc',
		docx: 'CoolDocx',
		doc: 'CoolDocx',
		pdf: 'CoolPdf',
		web: 'CoolLianjie',
		jpg: 'CoolLianjie',
		jpeg: 'CoolLianjie',
		png: 'CoolLianjie',
	};
	return iconMap[icon];
};
const paramData = computed(() => {
	if (props.param) {
		let params = props.param;
		try {
			params = JSON.parse(props.param);
			delete params.web_source_list;
		} catch (error) {}
		let param_ = {};
		for (const key in params) {
			let value = params[key] ?? '';
			try {
				value = JSON.parse(value);
			} catch (error) {}
			try {
				let keyObj: any = chatStore.dialogueParamsListOld.filter((item) => {
					return item.key === key;
				})[0];
				const range_ = chatStore.pluginListAll;
				range_.forEach((rangeItem: any) => {
					if (typeof value === 'object') {
						value = value.map((valKey: any) => {
							return valKey === rangeItem.value ? rangeItem.label : valKey;
						});
					} else {
						value = value == rangeItem.value ? rangeItem.label : value;
					}
				});

				if (param_['数据源']) {
					if (param_['数据源'].indexOf('离线') != -1) {
						continue;
					}
				}
				if (keyObj.isSystem !== true) {
					param_[keyObj.name] = value;
				}
			} catch (error) {}
		}
		return param_;
	}
	return {};
});

const handlePluginOutput = computed(() => {
	const text = props.pluginOutput;
	const { result, isMarkdownImg: isMarkdown } = text ? textToMarkdown(text, []) : { result: '', isMarkdownImg: [] };
	isMarkdownImg.value = isMarkdown;
	let htmlStr = mdi.render(result);
	return addLoadEventToImgTags(htmlStr);
});
const getLeft=computed(()=>{
	let dom=document.querySelector('.fullWidth')
	if(dom){
		return -(dom?.offsetWidth)-35+'px'
	}
})
const getQuestionList = async () => {
	if(route.name=='share'){
	return
   }
	requestLoading.value = true;
	let res = await listDialogueQuestion(props.id);
	requestLoading.value = false;
	questionList.value = res?.data || [];
};
const probeText = ref('');
const getAiQuestionList = async () => {
	if(route.name=='share'){
	return
    }
	let res = await listDialogueQuestion(props.id);
	if (res.code == 200 && res.data) {
		probeText.value = res.data[0] || '';
	}
};
const changeQuestion = () => {
	questionList.value = [];
	if (!chatStore.isSensitive && !chatMode.value) {
		getQuestionList();
	}
};

const onClickOutside = (event) => {
	try {
		if (event.target.className.indexOf('probe-btn') < 0) {
			isProbe.value = false;
		}
	} catch (error) {}
};
//分享
const handleShare = () => {
	setItemChecked(true);
	chatStore.showCheck = true;
};
const setItemChecked = (val: boolean) => {
	let find = chatStore.chatList.filter((item: object) => {
		return item.id == props.id;
	});
	if (find.length) {
		find[0].checked = val;
	}
};
const handleeSelect = (val: boolean) => {
	let data = {
		checked: val,
		id: props.id,
	};
	emit('changeCheck', data);
};
const continueDialogue = (text) => {

	sendQuestion({ text }, 'continue');
};
const sendQuestion = (params: string, type?: string) => {
	if (chatStore.dialogueLoading) return;
	isProbe.value = false;
	let param = props.param;
	if (typeof param === 'object') {
		param = JSON.stringify(props.param);
	}
	let appId = typeof props.param === 'string' ? JSON.parse(props.param)?.promptId : props.param?.promptId;
	const data: any = {
		appId: appId,
		content: params.text,
		conversationId: route.params.conversationId,
		param,
		searchEngineIdList: params?.searchEngineIdList || [],
		searchEngineType: params?.searchEngineType,
	};
	if (type === 'continue') {
		data.perquisition = true;
	}
	/*if(props?.dialogueFileIds){
		data.dialogueFileIds = props?.dialogueFileIds
	}*/
	if (props?.dialogueFolderIds) {
		data.dialogueFolderIds = props?.dialogueFolderIds;
	}
	if (props?.paragraph) {
		data.paragraph = props?.paragraph;
	}
	/*if(props?.skillId){
		data.skillId = props?.skillId
	}*/
	data.dialogueFileIds = []; // 你还可以问提问时，不需要带上之前的文件id
	chatStore.setChatList(data);
	return;
};
const handleSelect = (key: 'copyText' | 'delete' | 'toggleRender', source: string = '') => {
	isProbe.value = false;
	let listIndex = props.index;
	if (key === 'up') {
		// isup.value = true;
		// isdown.value = false;
		isfinish.value = true;
		chatStore.chatList[listIndex].is_up = true;
		chatStore.chatList[listIndex].is_down = false;
		chatStore.chatList[listIndex].feedBackStatus = 1;
		// chatStore.lastItem.is_up = true
		// chatStore.lastItem.is_down = false
		// chatStore.lastItem.feedBackStatus = 1
		try {
			// chatStore.lastItem.regens[chatStore.lastItem.curIndex].feedBackStatus = chatStore.lastItem.feedBackStatus
			chatStore.lastItem.regens[chatStore.lastItem.curIndex].feedBackStatus = chatStore.chatList[listIndex].feedBackStatus;
		} catch (error) {}
		return;
	}
	if (key === 'down' || key === 'report') {
		// isdown.value = true;
		// isup.value = false;
		isfinish.value = true;
		// chatStore.lastItem.is_up = false
		// chatStore.lastItem.is_down = true
		// chatStore.lastItem.feedBackStatus = 0;
		chatStore.chatList[listIndex].is_up = false;
		chatStore.chatList[listIndex].is_down = true;
		chatStore.chatList[listIndex].feedBackStatus = 0;
		try {
			// chatStore.lastItem.regens[chatStore.lastItem.curIndex].feedBackStatus = chatStore.lastItem.feedBackStatus
			chatStore.lastItem.regens[chatStore.lastItem.curIndex].feedBackStatus = chatStore.chatList[listIndex].feedBackStatus;
		} catch (error) {}
		return;
	}
	if (key === 'copyText') {
		// clearTimeout(timer.value);
		// iscopy.value = true;
		let text = props.answer ?? '';
		text = text.replace(/:::r|◹|◸|:::|/g, '');
		text = text.replaceAll(/<span\b[^>]*>(.*?)<\/span>/g, '$1');//处理复制span标签包裹情况
		if (text === chatStore.errorText) {
			return;
		}
		copyText({ text });
		Message.success(t('chat.center.copySuccess'));
		// timer.value = setTimeout(() => {
		// 	iscopy.value = false;
		// }, 2000);
		return;
	}
	if (key === 'toggleRender') {
		if (chatStore.dialogueLoading) return;
		chatStore.regenRawItem = { ...chatStore.lastItem };
		let param = props?.param ||'';
		if (typeof param === 'object') {
			param = JSON.stringify(props.param);
		}
		if (source && source != '') {
			let data = JSON.parse(param);
			data.web_source_list = source;
			param = JSON.stringify(data);
		}
		let appId=21
		if(props?.param){
		 appId =typeof props.param === 'string' ? JSON.parse(props.param)?.promptId : props.param?.promptId;
		}
		const data: any = {
			appId: 21,
			content: props.question,
			regenerate: true,
			conversationId: route.params.conversationId,
			fileIds: [],
			groupId: props.groupId,
			param,
		};
		if (route.name != 'chat') {
			data.searchEngineType = props.searchEngineType || 0;
			let ids = [];
			if (props.searchEngineList.length) {
				props.searchEngineList?.forEach((item) => {
					ids.push(item.id);
				});
			}
			data.searchEngineIdList = ids;
			//针对内容有yayi-url的处理下
			data.content = data.content.replace(/<yayi-url[^>]*>(.*?)<\/yayi-url>/g, '$1');
		}
		if (props?.pluginSwitch) {
			data.pluginSwitch = props?.pluginSwitch;
		}
		if (props?.dialogueFileIds) {
			data.dialogueFileIds = props?.dialogueFileIds;
		}
		if (props?.dialogueFolderIds) {
			data.dialogueFolderIds = props?.dialogueFolderIds;
		}
		if (props?.fileUrl) {
			data.fileUrl = props?.fileUrl;
			data.fileId = props?.fileId;
			data.type = props?.type;
		}
		if (props?.paragraph) {
			data.paragraph = props?.paragraph;
		}
		if (props?.skillId) {
			data.skillId = props?.skillId;
		}
		if (props.files && props.files.length) {
			let typeList = ['png', 'jpg', 'jpeg', 'PNG', 'JPG', 'JPEG'];
			chatStore.fileUpdateCV.uploadLists = props.files.filter((item: any) => !typeList.includes(item.type));
			chatStore.fileUpdateCV.imgUrl = props.files.filter((item: any) => typeList.includes(item.type));
			chatStore.showUpload = false;
			props.files?.forEach((item) => {
				data.fileIds.push(item.id);
			});
			data.files = props.files;
		}
		if(props?.chatQuestion&&isNotEmptyObject(props?.chatQuestion)){
			for(let key in props?.chatQuestion){
				if(key in data){
				}else{
                     data[key]=props?.chatQuestion[key]
				} 
			}
		}else{

		}
		chatStore.setChatList(data);
		return;
	}
};

const range = (val) => {
	let value = val.range;
	if (val.type === 'ENUM') {
		value = value.map((item) => {
			if (item.indexOf('|') > -1) {
				let [value, label] = item.split('|').map((s) => s.trim());

				return { label, value };
			}
			let [value, label] = [item, item];
			return { label, value };
		});
	}
	return value;
};

const emit = defineEmits<Emit>();
const handleBofang = () => {
	chatStore.setAiRobotChat('break', true, 'break');
	chatStore.setAiRobotChat(appId == 20 ? '已为您生成画作' : props.answer, true);
	chatStore.setAiRobotChat('。');
};

const feedbacksubmit = async (type) => {
	if((type==1&&(!zanValue.value?.length&&!zanText.value))||(!type&&(!caiText.value&&! caiValue.value?.length))){
		Message.info('请先选择原因或者填写理由！');
		return
	}
	let data = {
		appId: appId || 21,
		dialogueId: props.id,
		feedback: type == 1 ? zanText.value : caiText.value,
		type: type,
		dialogueType: chatMode.value ? 'QA' : 'KNOWLEDGE_BASE',
		appRoleId: route.name=='chat'?roleConfig.getCurrentRole():route.name=='assistant'?roleConfig.kyId:roleConfig.searchId,
	};
	if (type == 1) {
		data.upvoteLabel = zanValue.value;
	} else {
		data.downvoteLabel = caiValue.value;
	}
	type == 1 ? handleSelect('up') : handleSelect('down');
	let res = await feedback(data);
	let msg = data.type == 1 ? t('chat.center.clickUpSuccess') : t('chat.center.clickDownSuccess');
	if (res.code == 200) {
		Message.success(msg);
	} else {
		isup.value = false;
		isdown.value = false;
	}
	if(type){
		showLikePop.value=false
	}else{
		showDisLikePop.value=false
	}
};

const copy = (val: string, fileUrl: string) => {
	let text = val || '';
	if (fileUrl) {
		text = fileUrl + text;
	}
	let urlReg = /<yayi-url status="([^<>'"]+)?" title="([^<>'"]+)?" wc="([^<>'"]+)?">([^<>'"]+?)<\/yayi-url>/g;
	const iterator = val.matchAll(urlReg);
	const arr = [...iterator];
	if (arr.length == 0) {
		text = val;
	} else {
		let e = 0;
		const i: any = [];
		arr.forEach((item) => {
			let n = item.index;
			const r = item[0];
			const g = val.slice(e, n);
			g && i.push(g);
			i.push(item[4]);
			e = n + r.length;
		});
		var m = val.length - e;
		if (m > 0) {
			i.push(val.slice(-m));
		}
		const s = i.join('');
		text = s;
	}
	copyText({ text });
	Message.success(t('chat.center.copySuccess'));
};
const edit = () => {
	mittBus.emit('editQestionToInput', props);
	// if (props.from == 'debug') {
	// 	mittBus.emit('editQestionToInputDebug', props);
	// } else {
	// 	mittBus.emit('editQestionToInput', props);
	// }
};
const popupchange = (val) => {
	if (!val) {
		caiValue.value = [];
		zanValue.value = [];
		caiText.value = '';
		zanText.value = '';
	}
};

const copyCode = () => {
	const text = exampleCode.value;
	copyText({ text });
	Message.success(t('chat.center.copySuccess'));
};
const getExport = async () => {
	exportVisible.value = true;
	let param = props.param;
	if (typeof param === 'object') {
		param = JSON.stringify(props.param);
	}
	let data = JSON.parse(param);
	param = JSON.stringify(data);
	const dataList = {
		appId: chatMode.value ? data.promptId : 'CWDWD',
		content: props.question,
		conversationId: route.params.conversationId,
		param,
	};
	const res = await dialogueCode(dataList);
	exampleCode.value = res.data.code;
	htmlStrcode.value = mdi.render('```java\n' + res.data.code + '\n```');
};

const isShowDetail = ref(false);
const handlePluinDetail = () => {
	isShowDetail.value = !isShowDetail.value;
};

const handleFeedbackClick = (type: 'like' | 'dislike') => {
	const message = type === 'like' ? t('chat.center.cannotUp') : t('chat.center.cannotDown');
	Message.info(message);
};
const cancelModel = () => {
	reportVisible.value = false;
	showDisLikePop.value = false;
};
const confirmModel = async () => {
	if (!reportLabel.value.length) {
		Message.info(t('chat.center.selectLabel'));
		return;
	}
	let data = {
		appId: appId || 21,
		dialogueId: props.id,
		reportLabel: reportLabel.value,
		feedback: reportText.value,
		type: 2,
		appRoleId: route.name=='chat'?roleConfig.getCurrentRole():route.name=='assistant'?roleConfig.kyId:roleConfig.searchId,
	};
	handleSelect('report');
	let res = await feedback(data);
	if (res.code == 200) {
		Message.success(t('chat.center.reportSuccess'));
	} else {
		isup.value = false;
		isdown.value = false;
		Message.info(res.msg);
	}
	reportVisible.value = false;
	showDisLikePop.value = false;
};
const openWriter = () => {
	const { origin } = window.location;
	window.open(`${origin}/writer`, '_blank');
}
const openReport = async () => {
	reportList.value = [];
	reportLabel.value = [];
	reportText.value = '';
	let roleId = route.name=='chat'?roleConfig.getCurrentRole():route.name=='assistant'?roleConfig.kyId:roleConfig.searchId;
	let dom=document.querySelector('.upPopover')
	if(dom){
		dom.style.opacity=0
	}
	

	let res = await feedbackListLabel(roleId, 2);
	if (res?.code == 200) {
		reportList.value = res.data;
		res.data.forEach((item: any) => {
			item.select = false;
		});
	} else {
		Message.info(res?.msg);
	}
	reportVisible.value = true;
};
const handleReport = (item: object) => {
	item.select = !item.select;
	if (item.select) {
		reportLabel.value.push(item.id);
	} else {
		reportLabel.value = reportLabel.value.filter((id: any) => id != item.id);
	}
};
watch(
	() => props.feedBackStatus,
	(newVal: any) => {
		if (newVal == 1) {
			isup.value = true;
			isdown.value = false;
		} else if (newVal == 0) {
			isdown.value = true;
			isup.value = false;
		} else if (newVal == 2) {
			isdown.value = true;
			isup.value = false;
		} else {
			isup.value = false;
			isdown.value = false;
		}
	},
	{
		immediate: true,
		deep: true,
	}
);
watch(
	() => props.checked,
	(newVal: any) => {
		checkBoxValue.value = newVal;
	},
	{
		deep: true,
	}
);

watch(
	() => isQuestionStatus.value,
	(newVal: any) => {
		if (newVal == true && props.id && props.id !== 'undefined' && !chatStore.isSensitive && !chatMode.value) {
			getQuestionList();
		}
		if (newVal == true && props.id && props.id !== 'undefined' && props.messageAgent === 'search') {
			getAiQuestionList();
		}
	},
	{
		immediate: true,
		deep: true,
	}
);
</script>
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.1s;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
@mixin text() {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.left-item {
	width: 440px;
	height: 46px;
	margin-top: 14px;
	background: #ffffff;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;
	border-radius: 14px;
	cursor: pointer;
	&:hover {
		background: rgba(53, 94, 255, 0.06);
		color: #355eff;
	}
	&:hover .pointer {
		animation: moveHand 1s linear infinite;
	}
	
	.item-name {
		display: flex;
		align-items: center;
		.name {
			font-size: var(--font16);
			color: #181b49;
		}
		.icon {
			margin-right: 8px;
		}
		.upload{
		img{
			width:16px;
			height: 16px;
			margin-right: 8px;
		}
	}
	}
	.item-arrow {
		display: flex;
		align-items: center;
		.icon {
			margin-right: 5px;
		}
		.hot {
			font-size: var(--font14);
			color: #9a99aa;
			margin-right: 16px;
		}
	}
}
.font16 {
	font-size: var(--font16) !important;
}
.isPaddingLeft {
	// padding-right: 100px;
	padding-right: calc(40px + 0.5rem);
	.link {
		color: #355eff;
	}
}
.isPaddingLeftMobile {
	// padding-right: 10%;
}
.isPaddingRight {
	// padding-left: 100px;
	padding-left: calc(40px + 0.5rem);
	padding-right: initial;
}
.isPaddingRightMobile {
	padding-left: 10%;
	padding-right: initial;
}
.tagList {
	color: #9a99aa;
	.tip {
		display: inline-block;
		padding: 0 8px;
		color: #ccc;
	}
	&:last-child {
		.tip {
			display: none;
		}
	}
}
.pluinDetailBtn {
	cursor: pointer;
	color: #9a99aa;
	display: flex;
	align-items: center;
}
.pluinDetailContent {
	text-align: left;
	font-size: var(--font14);
	color: #646479;
	line-height: 19px;
	margin-top: 8px;
	padding: 1rem;
	border-radius: 16px;
	background: rgba(53, 94, 255, 0.03);
	.m-b {
		margin-bottom: 4px;
	}
	.no {
		margin-bottom: 0px;
	}
}
.message-tip {
	padding: 0 1rem;
	color: #646479ba;
	font-size: 13px;
}
.continue-text {
	color: #646479ba;
	font-size: 13px;
	padding: 0.5rem 1rem;
	button {
		padding: 0;
		font-size: inherit;
		border: none;
	}
}
.bofang-btn {
	background: #fff !important;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
	width: 36px !important;
	height: 36px !important;
	color: #9a99aa !important;
}
.btns {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	margin-top: 6px;
	.cool-icon {
		color: #9a99aa;
	}
	.otherBtn {
		display: flex;
		align-items: center;
	}

	.w-btn {
		width: 24px;
		height: 24px;
		color: #646479;
		// background: #fff;
		margin-left: 10px;
		// box-shadow: 0px 6px 20px 0px rgba(30,64,175,0.1);
	}
	.probe-btn {
		width: initial;
		padding: 0 5px;
		margin: 0;
	}

	.rebuildBtn {
		font-size: var(--font14);
		color: #646479;
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 12px;
		margin-left: 0;
		cursor: pointer;
		.w-btn {
			margin-right: 40px;
		}
		:deep(.w-btn-icon) {
			margin-right: 3px;
		}
		.cxsc {
			width: fit-content;
			padding: 0 5px;
			margin: 0 20px 0 0;
			.title{
				opacity: 0;
			}
			&:hover .title{
				opacity: 1;
			}
		}
		.mobileCxcs {
			margin-right: 5px;
		}
	}
}
.flex-row {
	:deep(.w-trigger-popup) {
		// z-index: 1 !important;
	}
}

.question {
	// border-top: 1px solid rgba(0, 0, 0, 0.1);
	.btns {
		width: 100%;
		padding: 0 1rem;
		box-sizing: border-box;
		margin-top: 20px;
		margin-bottom: 11px;
		color: #646479;
		.rebuildBtn {
			color: #646479 !important;
			margin-right: 16px;
			.cool-icon {
				color: #646479;
			}
			span:hover {
				color: var(--color-text-1);
				background-color: var(--color-fill-2);
				border-color: transparent;
				.cool-icon {
					color: var(--color-text-1);
				}
			}
		}
		.tutle {
			font-size: var(--font14);
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #646479;
		}
	}
	.item {
		width: 100%;
		padding: 0 1rem;
		box-sizing: border-box;
		line-height: 34px;
		border-radius: 16px;
		// border: 1px solid #E4E8EE;
		font-size: var(--font14);
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #646479;
		position: relative;
		box-sizing: border-box;
		cursor: pointer;
		margin-top: 8px;
		overflow: hidden;
		.icon {
			// position: absolute;
			// right: 1rem;
			margin-top: 6px;
			margin-bottom: 6px;
			float: right;
			display: none;
		}
		&:hover {
			color: var(--w-color-primary);
			background: rgba(255, 255, 255, 0.5);
			.icon {
				display: block;
			}
		}
	}
	.item:nth-child(1) {
		margin-top: 0;
	}
	.questionfooter {
		margin-top: 5px;
		margin-bottom: 0;
	}
}
.check-box {
	// position: relative;
	// right:500px;
	position: relative;
	.check {
		position: absolute;
		top: 10px;
		left:-50px;
	}
}
.isMobileCheck {
	:deep(.w-checkbox-icon) {
		left: 0px !important;
	}
}
.mobileBtns {
	padding: 0px 10px 10px !important;
}
.adaption{
	padding-bottom: 15px;
}
.dcm-info{
	display: flex;
	margin-top: -5px;
	font-size: var(--font12);
	color:#646479;
	height: 50px;
	.text{
	   display: flex;
	   align-items: center;
       width: fit-content;
	   height: 24px;
	   padding: 0 10px;
	   border-radius: 14px;
	   background: #F4F6F9;
	}

}
.fullWidth{
	width: 100%;
}
.copyQuestion,.editQuestion{
	display: inline-block;
	padding: 2px 4px;
	&:hover{
		background-color: var(--active-bg-menu);
		border-radius: 4px;
	}
	// background-color: red;
}
</style>
<style lang="scss">
.markdown-body-detail {
	font-size: var(--font14);
	a {
		height: auto;
		top: -2px;
	}
}
.popoverClass {
	background: linear-gradient(130deg, #ffffff 0%, #ffffff 100%), linear-gradient(180deg, #f7f5ff 0%, rgba(239, 243, 251, 0) 100%) !important;
	box-shadow: 0px 6px 20px 0px rgba(30, 64, 175, 0.06) !important;
	h2 {
		color: #646479;
	}
	.w-checkbox-group {
		display: flex;
		flex-wrap: wrap;
	}
	.w-checkbox {
		min-width: 50%;
	}
	.w-popconfirm-body {
		margin-bottom: 12px !important;
	}
	.popcontent {
		width: 280px;
	}
	.bottomBtn {
		position: absolute;
		bottom: -36px;
		left: 5px;
		display: flex;
		align-items: center;
		cursor: pointer;
		.title {
			padding-left: 3px;
			font-size: var(--font14);
			color: #646479;
		}
	}
	.w-popconfirm-icon {
		display: none !important;
	}
	.w-textarea-word-limit {
		background: #fff;
	}
	.w-checkbox-group-direction-vertical {
		.w-checkbox {
			line-height: 20px;
			margin: 10px 0;
		}
	}
	.w-textarea-wrapper {
		border-radius: 8px;
		border: 1px solid #d0d5dc;
	}
	.w-btn {
		border-radius: 8px !important;
	}
	.w-btn-text {
		border: 1px solid #d0d5dc !important;
	}
}
</style>
<style lang="scss" >
.exampleModal {
	background: linear-gradient(130deg, #dfeafc 0%, #ffffff 100%), linear-gradient(180deg, #ede7ff 0%, rgba(239, 243, 251, 0) 100%);
	border-radius: 12px;
	.markdown-body {
		pre {
			overflow: initial;
			code.hljs {
				overflow: initial;
			}
		}
	}
	.w-icon {
		width: 1.5em;
		height: 1.5em;
	}
	.detail {
		font-size: var(--font16);
		line-height: 32px;
		color: #181b49;
		height: 287px;
		overflow: auto;
		height: 540px;
		border-radius: 8px;
		> span {
			padding: 0 2px;
			color: #355eff;
		}
	}
	.exampleClass {
		background: #fff;
		border-radius: 8px;
		.ff {
			text-align: right;
			color: #355eff;
			cursor: pointer;
			display: flex;
			justify-content: space-between;
			height: 40px;
			background: #f6f8ff;
			border-radius: 8px 8px 0px 0px;
			line-height: 40px;
			padding: 0 10px;
			.tabs {
				color: #646479;
				font-size: var(--font16);
			}
		}
	}
	.w-tabs-tab-title {
		font-size: var(--font16);
	}
	.w-tabs-nav::before {
		height: 0;
	}
	.w-tabs-tab {
		margin: 0 10px;
	}
	.w-tabs-tab-active {
		.w-tabs-tab-title {
			color: #181b49;
		}
	}
	.markdown-body {
		overflow-x: initial;
	}
}
.reportModal {
	width: 90% !important;
	max-width: 510px !important;
	border-radius: 8px;
	.w-modal-title {
		color: #181b49;
	}
	.w-modal-header {
		padding: 20px 32px !important;
	}
	.content {
		padding-bottom: 22px;
		.head {
			font-size: var(--font14);
			display: flex;
			align-items: center;
			margin-bottom: 12px;
			.red {
				color: #f54b5b;
				padding-right: 2px;
			}
			.title {
				color: #646479;
			}
		}
		.list {
			display: flex;
			flex-wrap: wrap;
			.list-item {
				display: flex;
				padding: 8px 18px;
				background: #ffffff;
				border-radius: 8px;
				border: 1px solid #d0d5dc;
				cursor: pointer;
				margin-right: 8px;
				margin-bottom: 8px;
				font-size: var(--font14);
				color: #646479;
			}
			.active {
				background: rgba(53, 94, 255, 0.1);
				border-color: #355eff;
				color: #355eff;
			}
		}
		.input-box {
			margin-top: 12px;
			.title {
				font-size: var(--font14);
				color: #646479;
				margin-bottom: 8px;
			}
			.w-textarea-wrapper {
				border-radius: 8px;
				border: 1px solid #d0d5dc;
				padding-bottom: 20px;
			}
		}
		.btns {
			margin-top: 26px;
			display: flex;
			justify-content: flex-end;
			.cancel {
				border-radius: 8px;
				border: 1px solid #d0d5dc;
				padding: 8px 18px;
				background: #fff;
				font-size: var(--font14);
				color: #646479;
				margin-right: 12px;
				cursor: pointer;
			}
			.confirm {
				border-radius: 8px;
				border: 1px solid #355eff;
				padding: 8px 18px;
				font-size: var(--font14);
				color: #fff;
				background: #355eff;
				cursor: pointer;
			}
		}
	}
}
</style>
